export default {
  setScaleSheetProfiles (state, profiles) {
    state.scaleSheetProfiles = profiles
  },
  setLoading (state, loading) {
    state.loading = loading
  },
  setTicketBooks (state, ticketBooks) {
    state.ticketBooks = ticketBooks
  }
}
